import React from 'react';
import { formatPrice, type Product, type ProductStatusLabel } from '../../data/products';

/**
 * The four status labels a piece can carry, in this site's palette. These
 * are real status (how many exist, who made it, whether it is café
 * merchandise) rather than decorative category pills, so they earn their
 * weight.
 */
const LABEL_TONE: Record<ProductStatusLabel, string> = {
  'One of One': 'bg-flame text-white',
  Handmade: 'bg-moss/20 text-ink',
  'Limited Stock': 'bg-moss text-white',
  'Low On Fuel Merchandise': 'bg-ink text-cream'
};
export function ProductStatusBadge({
  label
}: {
  label: ProductStatusLabel;
}) {
  return <span className={`inline-flex items-center rounded-control px-2 py-1 text-[11px] font-bold uppercase tracking-[0.08em] ${LABEL_TONE[label]}`} data-id="element-147" data-mp="3nq51xm7kw7vv">
      {label}
    </span>;
}
export function SoldBadge() {
  return <span className="inline-flex items-center rounded-control bg-ink-deep px-2.5 py-1 text-[11px] font-bold uppercase tracking-[0.12em] text-cream" data-id="element-148" data-mp="p04t3xa9qrds">
      Sold
    </span>;
}
export function ProductPrice({
  price,
  className = ''
}: {
  price: number;
  className?: string;
}) {
  return <span className={`font-bebas leading-none tracking-wide text-rust ${className}`} data-id="element-149" data-mp="3rlycr868hhb6">
      {formatPrice(price)}
    </span>;
}

/**
 * Stock in words, never colour alone. Each state carries a shape, a colour
 * and a text label.
 */
export function StockStatus({
  product
}: {
  product: Product;
}) {
  if (product.sold) {
    return <span className="flex items-center gap-1.5 text-sm font-bold text-ink-muted" data-id="element-150" data-mp="evlkgqebb0y">
        <span aria-hidden="true" data-id="element-151" data-mp="eeddv62wh6f2">■</span>
        Found a new garage
      </span>;
  }
  if (product.oneOff) {
    return <span className="flex items-center gap-1.5 text-sm font-bold text-moss" data-id="element-152" data-mp="9gv63j0mcx8n">
        <span aria-hidden="true" data-id="element-153" data-mp="2g7krmb2v7fyu">●</span>
        Just the one
      </span>;
  }
  if (product.stockQuantity <= 3) {
    return <span className="flex items-center gap-1.5 text-sm font-bold text-flame" data-id="element-154" data-mp="2b9t2fotlu7yc">
        <span aria-hidden="true" data-id="element-155" data-mp="f64saq90sz98">▲</span>
        Only {product.stockQuantity} left
      </span>;
  }
  return <span className="flex items-center gap-1.5 text-sm font-medium text-ink-muted" data-id="element-156" data-mp="k5r4cwd449gg">
      <span aria-hidden="true" data-id="element-157" data-mp="p16izqiy29dx">●</span>
      In stock
    </span>;
}